import { ActionBar, ButtonVariant, StyledFlex } from '@dreryk/react-components';

import { noop } from '~libs.typescript';

import { translationKeys } from '../translations';

import { EmergencyNotificationConfigurationForm } from './form/EmergencyNotificationConfigurationForm';
import { EmergencyNotificationSettingsPanelLoader } from './EmergencyNotificationSettingsPanel.loader';
import { EmergencyNotificationConfigurationSetActionEventInterceptor } from './form/interceptors/EmergencyNotificationConfigurationSetActionEventInterceptor';

export const EmergencyNotificationSettingsPanel = (): JSX.Element => {
   return (
      <EmergencyNotificationSettingsPanelLoader>
         {({ emergencyNotificationConfiguration, practitioners }) => (
            <ActionBar testId={'emergencyNotificationConfiguration'} id={'emergencyNotificationConfiguration'}>
               <StyledFlex direction={'column'} gap={'16px'}>
                  <EmergencyNotificationConfigurationForm
                     emergencyNotificationConfiguration={emergencyNotificationConfiguration}
                     practitioners={practitioners}
                  >
                     {({ handleSubmit }) => (
                        <EmergencyNotificationConfigurationSetActionEventInterceptor
                           handleSubmit={handleSubmit}
                           emergencyNotificationConfiguration={emergencyNotificationConfiguration}
                        >
                           <ActionBar.PrimaryButton
                              testId={'save'}
                              label={translationKeys.save}
                              onClick={noop}
                              variant={ButtonVariant.PRIMARY}
                              blockingOperation
                           />
                        </EmergencyNotificationConfigurationSetActionEventInterceptor>
                     )}
                  </EmergencyNotificationConfigurationForm>
               </StyledFlex>
            </ActionBar>
         )}
      </EmergencyNotificationSettingsPanelLoader>
   );
};
